<script setup>
import DataFilterPopup from './DataFilterPopup.vue'

const props = defineProps(['filters'])

const { t } = useI18n()

const isDesktopMenuOpen = ref(false)
const dropdown = ref(null)

function close() {
  isDesktopMenuOpen.value = false
}

function open() {
  isDesktopMenuOpen.value = true
}
</script>

<template>
  <div class="inline-flex">
    <DSDropdown
      ref="dropdown"
      class="h-40px w-full flex flex-row cursor-default items-center justify-between flex-gap-x-2 rounded bg-white px-4 py-2 text-left shadow-none ring-1 ring-surface-700 ring-inset lt-sm:text-sm"
      :class="[isDesktopMenuOpen ? 'ring-secondary' : 'ring-surface-700']"
      menu-items-classes="rounded-8px py-2 no-underline min-w-154px"
      manual-close
      @open="open()"
      @close="close()"
    >
      <template #label>
        <div class="me-2 flex flex-row items-center">
          <div class="me-2">
            <DSIcon
              size="24"
              icon="i-far-plus"
            />
          </div>
          <span class="text-text-500">{{ t('Add Filter') }}</span>
        </div>
      </template>
      <template #icon>
        <div
          class="base-dropdown-icon flex-shrink-0"
          aria-hidden="true"
        >
          <DSIcon
            icon="i-far-chevron-down"
            size="24"
          />
        </div>
      </template>
      <div class="min-w-full w-max">
        <div
          v-for="(filter, index) in filters"
          :key="`filter_${index}`"
        >
          <DataFilterPopup
            :filter="filter"
            :position="{ top: 0, left: 'calc(100% + 8px)' }"
            @apply="dropdown && dropdown.close()"
          >
            <button
              class="w-full flex select-none px-4 py-2.5 text-sm text-text-500 hover:bg-gray-100 hover:no-underline"
            >
              {{ filter.isLabelNoun !== false ? `${t('Any')} ` : ''
              }}{{ filter.label }}
            </button>
          </DataFilterPopup>
        </div>
      </div>
    </DSDropdown>
  </div>
</template>

<i18n>
{
  "en-us": {
    "Any": "Any",
    "Add Filter": "Add Filter"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Add Filter": "Filter hinzufügen",
  "Any": "Alle"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Add Filter": "Ajouter un filtre",
  "Any": "Tous"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Add Filter": "Añadir filtro",
  "Any": "Cualquiera"
}
</i18n>
